import { render, staticRenderFns } from "./code-mirror.vue?vue&type=template&id=056d4c20&"
import script from "./code-mirror.vue?vue&type=script&lang=ts&"
export * from "./code-mirror.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports